<ngb-progressbar type="{{ type }}" [value]="percent"></ngb-progressbar>
